const menu = [
  {
    title: '首页',
    icon: 'icon-iconfonthome0',
    routerName: 'index',
    selected: false,
    group: 'index',
    children: []
  },
  {
    title: '产品',
    icon: 'icon-chanpinzhengce',
    routerName: '',
    selected: false,
    children: [
      {
        title: '船票套餐',
        routerName: 'product.ship',
        selected: false,
        group: 'shipList',
        privilege_id: 1
      },
      {
        title: '线路套餐',
        routerName: 'product.trip',
        selected: false,
        group: 'tripList',
        privilege_id: 2
      },
      {
        title: '景区门票',
        routerName: 'product.scenic',
        selected: false,
        group: 'scenicList',
        privilege_id: 3
      },
      {
        title: '预约套餐',
        routerName: 'product.booking',
        selected: false,
        group: 'bookingList',
        privilege_id: 4
      },
      {
        title: '直播列表',
        routerName: 'product.live',
        selected: false,
        group: 'liveList',
        privilege_id: 6
      }
    ]
  },
  {
    title: '订单',
    icon: 'icon-huabanfuben',
    routerName: '',
    selected: false,
    children: [
      {
        title: '船票订单',
        routerName: 'order.order_list.ship',
        selected: false,
        group: 'orderList',
        privilege_id: 7
      },
      {
        title: '线路订单',
        routerName: 'order.order_list.trip',
        selected: false,
        group: 'tripLineOrder',
        privilege_id: 8
      },
      {
        title: '景区订单',
        routerName: 'order.order_list.scenic',
        selected: false,
        group: 'scenicOrder',
        privilege_id: 9
      },
      {
        title: '预约订单',
        routerName: 'order.order_list.booking',
        selected: false,
        group: 'bookingOrder',
        privilege_id: 10
      },
      {
        title: '全部订单',
        routerName: 'order.order_list.all',
        selected: false,
        group: 'allOrder',
        privilege_id: 11
      },
      {
        title: '退款申请',
        routerName: 'refund.refund_list',
        selected: false,
        group: 'refundList',
        privilege_id: 12
      },
      {
        title: '提现申请',
        routerName: 'cash.apply_list',
        selected: false,
        group: 'cash',
        privilege_id: 13
      },
      {
        title: '船票对账',
        routerName: 'order.reconciliation_list',
        selected: false,
        group: 'orderReconciliation',
        privilege_id: 29
      }
    ]
  },
  {
    title: '用户',
    icon: 'icon-yonghuming',
    routerName: '',
    selected: false,
    children: [
      {
        title: '用户列表',
        routerName: 'user.user_list',
        selected: false,
        group: 'userList',
        privilege_id: 17
      },
      {
        title: '用户组',
        routerName: 'user.group_list',
        selected: false,
        group: 'group',
        privilege_id: 18
      },
      {
        title: '讲解员管理',
        routerName: 'user.guide_list',
        selected: false,
        group: 'guideList',
        privilege_id: 19
      }
    ]
  },
  {
    title: '配置',
    icon: 'icon-dashujukeshihuaico-',
    routerName: '',
    selected: false,
    children: [
      {
        title: '航班管理',
        routerName: 'settings.sailings',
        selected: false,
        group: 'sailings',
        privilege_id: 20
      },
      {
        title: '预约场次',
        routerName: 'settings.booking.plays_list',
        selected: false,
        group: 'plays_list',
        privilege_id: 21
      },
      {
        title: '产品分类',
        routerName: 'settings.cate',
        selected: false,
        group: 'cate',
        privilege_id: 22
      },
      {
        title: '运营豆',
        routerName: 'settings.op_wallet.op_wallet',
        selected: false,
        group: 'op_wallet',
        privilege_id: 30
      },
      {
        title: '全局设置',
        routerName: 'settings.settings',
        selected: false,
        group: 'settings',
        privilege_id: 24
      },
      {
        title: '合同模板',
        routerName: 'contract.template_list',
        selected: false,
        group: 'contractTemplate',
        privilege_id: 31
      },
      {
        title: '供应商管理',
        routerName: 'supplier.list',
        selected: false,
        group: 'supplier',
        privilege_id: 32
      },
    ]
  },
  {
    title: '微信管理',
    icon: 'icon-dashujukeshihuaico-',
    routerName: '',
    selected: false,
    children: [

      {
        title: '微信搜一搜',
        routerName: 'settings.soso.config_list',
        selected: false,
        group: 'soso',
        privilege_id: 25
      },
      {
        title: '小程序管理',
        routerName: 'settings.apps.app_list',
        selected: false,
        group: 'apps',
        privilege_id: 26
      },
    ]
  },
  {
    title: '管理员',
    icon: 'icon-guanliyuan',
    routerName: '',
    selected: false,
    children: [
      {
        title: '管理员列表',
        routerName: 'settings.admin_list',
        selected: false,
        group: 'admin',
        privilege_id: 27
      },
      {
        title: '管理员用户组',
        routerName: 'settings.admin_group',
        selected: false,
        group: 'admin_group',
        privilege_id: 28
      },
    ]
  }
];
export default menu;



// WEBPACK FOOTER //
// ./src/config/left_menu.js